import urls from 'constants/urls';
import locator from 'utils/locator';

const QUICK_SHOP_LABEL = 'Quick Shop Regulars';

// TODO: refactor to a scalable solution using `react-router-dom` `matchPath`
// to handle all listing pages
export const getProductFindingMethod = (): string | undefined => {
  if (locator.pathname === urls.quickShop) {
    return QUICK_SHOP_LABEL;
  }

  return undefined;
};
